import { render, staticRenderFns } from "./radiobroadcast.vue?vue&type=template&id=47850cdc&scoped=true&"
import script from "./radiobroadcast.vue?vue&type=script&lang=js&"
export * from "./radiobroadcast.vue?vue&type=script&lang=js&"
import style0 from "./radiobroadcast.vue?vue&type=style&index=0&id=47850cdc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47850cdc",
  null
  
)

export default component.exports